// FontAwesome yalnız Pro 6 CSS/webfont olarak yüklenir; ikonlar <i class="fa-…"> ile basılır.
// Dinamik ikon değerleri (backend sınıf dizesi, [prefix, name]) $faIcon ile sınıfa çevrilir.
import '@fortawesome/fontawesome-pro/css/all.css'
// SVG dönemindeki ikon görünümü tema kurallarında: assets/css/light/icons.scss
import FaIconPlugin from '../utils/faIcon'

export default FaIconPlugin
